<div class="dialog">
  <h2>
    New IDC Credentials
  </h2>
  <p>
    This is the only time the IDC Key Secret can be viewed or downloaded. You cannot recover it later. However, you can create a new key at any time.
  </p>

  @if (!credentials) {
    <app-spinner>
      Generating credentials...
    </app-spinner>
  }

  @if (credentials) {
    <div class="detail">
      <app-text-input
        [name]="keyIdLabel"
        [value]="credentials.accessKeyId"
        readonly="true"
      ></app-text-input>
      <button type="button" class="btn btn-primary copy-button" [appCopyValue]="credentials.accessKeyId">
        <div class="copied-hide">Copy</div>
        <div class="copied-show">Copied</div>
      </button>
    </div>
    <div class="detail">
      <app-text-input
        [name]="keySecretLabel"
        [value]="credentials.accessKeySecret"
        type="password"
        labelName="Secret"
        readonly="true"
      ></app-text-input>
      <button type="button" class="btn btn-primary copy-button" [appCopyValue]="credentials.accessKeySecret">
        <div class="copied-hide">Copy</div>
        <div class="copied-show">Copied</div>
      </button>
    </div>
    <div class="button-grid">
      <button class="btn btn-secondary" (click)="download()">
        <img alt="" class="inset-icon" src="/assets/default/download.svg">
        Download CSV file
      </button>
      <button class="btn btn-primary" (click)="onDoneClick()">
        Done
      </button>
    </div>
  }
</div>
